import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6093c0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold m-discount" }
const _hoisted_2 = {
  key: 0,
  class: "m-discount-redeem"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "m-discount-confirm" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "m-discount-redeemed"
}
const _hoisted_7 = { class: "m-discount-redemption" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_token = _resolveComponent("m-token")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.activeEligibleToken)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h1", null, _toDisplayString('Redeem this token to get ' + _ctx.state.description), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
            }, "Cancel"),
            _createElementVNode("button", {
              disabled: _ctx.isSubmittingRedemption,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitSelection && _ctx.submitSelection(...args)))
            }, " Submit ", 8, _hoisted_5)
          ])
        ]))
      : (_ctx.state.activeRedemption)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_m_token, { token: _ctx.redemptionToToken }, null, 8, ["token"]),
              (_ctx.state.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("h1", null, _toDisplayString('Congratulations! You can use this one time discount code to get ' + _ctx.state.description), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_ctx.state.activeRedemption.submissions[0].discountCode), 1)
            ]),
            _createElementVNode("a", {
              href: `${'//' + _ctx.state.activeRedemption.submissions[0].shop}`
            }, _toDisplayString(_ctx.buttonText), 9, _hoisted_9)
          ]))
        : _createCommentVNode("", true)
  ]))
}